import React, {useEffect, useState} from "react";
import TextBox from "devextreme-react/text-box";
import {formatMessage} from "devextreme/localization";
import Validator, { RequiredRule } from "devextreme-react/validator";
import {formatMessageExt} from "../../utils/helpers";
import Button from "devextreme-react/button";
import ValidationGroup from "devextreme-react/validation-group";
import {SingleCard} from "../../layouts";
import LoadIndicator from "devextreme-react/load-indicator";
import notify from "devextreme/ui/notify";
import {useAppState} from "../../contexts/app-state";
import {Alert} from "../index";

export default ({url, icon, children, disabled, onaySuresi, onTimeout, onSuccess, onUnSuccess}) => {
    const { state } = useAppState();
    const [isBusy, setIsBusy] = useState(false);
    const [code, setCode] = useState(false);
    const [validationError, setValidationError] = useState(false);
    const [counter, setCounter] = useState(onaySuresi);

    useEffect(()=>{
        if (onaySuresi > 0) {
            const interval = setInterval(()=> {
                    setCounter(counter => {
                        //console.log('Tick ' + interval)
                        const remain = counter -1;
                        if (remain < 0) {
                            if (!isBusy) {
                                clearInterval(interval);
                                onTimeout();
                            }
                        }
                        return remain;
                    });
                }, 1000)

            return () => clearInterval(interval);
        }

    }, [])

    const onayKoduDogrula = (e) => {
        if (!e.validationGroup.validate().isValid) {
            return;
        }

        setValidationError(false);
        setIsBusy(true);

        fetch(url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json'},
                body: JSON.stringify( { code })
            })
            .then((response) => response.json())
            .then((res) => {
                if (res.success) {
                    onSuccess(res);
                } else {
                    if (res.finished) {
                        onUnSuccess(res);
                    } else {
                        setValidationError(res.message);
                        setIsBusy(false);
                    }
                }
            })
            .catch((error) => {
                notify(formatMessage('oops'), "error", 2000);
                if (state.debug) {
                    console.error(error);
                }
                setIsBusy(false);
            });
    }

    return <SingleCard hideFooter={true}
                       title={formatMessage('onayKodu.kod')}
                       page="OnayKoduSayfa">
        {validationError && <Alert type="error"
                                   message={validationError}
                                   iconClass="fa fa-2x fa-exclamation-circle"/>}
        <ValidationGroup>
        <div className="kq-form">

            <p style={{textAlign:"center"}}>
                <i className={icon} />
            </p>

            {onaySuresi > 0 && <p  style={{textAlign:"center"}}>
                {counter}
            </p>}

            <p>
                {children}
            </p>

        <TextBox placeholder={formatMessage('onayKodu.kod')}
                 readOnly={disabled}
                 autoComplete="off"
                 value={code}
                 onValueChanged={(e)=>setCode(e.value)}
                 stylingMode={'filled'}>
            <Validator>
                <RequiredRule message={formatMessageExt('validation.isRequired', ['onayKodu.kod'])} />
            </Validator>
        </TextBox>

        <br/>
        <Button width="100%"
                type="default"
                disabled={isBusy}
                onClick={onayKoduDogrula}>
            <span className="dx-button-text">
              {
                  isBusy
                      ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                      : formatMessage('onayKodu.dogrula')
              }
            </span>
        </Button>
    </div>
    </ValidationGroup>
    </SingleCard>
}